export default __webpack_public_path__ + "static/media/logo-fantom.40755d1e.png";